import '../styles/index.css';
import '@tremor/react/dist/esm/tremor.css';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { useAppSelector } from '../../app/hooks';
import { useDisableBodyScroll } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectSidebarState } from '../../features/sidebar/SidebarSlice';
import {
  selectActiveOrder,
  selectIsModalOpen,
  selectModalComponentActive,
} from '../../features/campaigns/campaignsSlice';
import Modal from '../../features/campaigns/modals/Modal';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import Loader from '../../features/campaigns/loader/Loader';

const Root = () => {
  const rootState = useAppSelector(selectSidebarState);
  const isModalOpen = useAppSelector(selectIsModalOpen);
  const activeOrder = useAppSelector(selectActiveOrder);
  const modalComponentActive = useAppSelector(selectModalComponentActive);
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if we're on the root path
    if (location.pathname === '/') {
      if (user) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }
  }, [user, navigate, location.pathname]); // Only depend on pathname to avoid loops

  useDisableBodyScroll(isModalOpen);

  // Show loading state while authentication is being checked
  if (loading) {
    return (
      <div
        id="pzo__app"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <>
      {user && (
        <div
          id="pzo__app"
          className={
            rootState.isSidebarOpen ? 'sidebar--open' : 'sidebar--closed'
          }
        >
          <Sidebar />
          <div id="pzo__main">
            <Topbar />
            <Outlet />
          </div>
          {isModalOpen && (
            <Modal order={activeOrder} state={isModalOpen}>
              {modalComponentActive && modalComponentActive}
            </Modal>
          )}

          <Toaster
            position="top-center"
            reverseOrder={false}
            toastOptions={{
              duration: 5000,
              style: {
                background: '#fff',
                color: '#374151',
              },
            }}
          />
        </div>
      )}

      {!user && (
        <div id="pzo__app">
          <Outlet />
          <Toaster
            position="top-center"
            reverseOrder={false}
            toastOptions={{
              duration: 5000,
              style: {
                background: '#fff',
                color: '#374151',
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default Root;
